module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('default-layout', [_c('div', {
    staticClass: "max-w-screen-3xl"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5"
  }, _vm._l((_vm.supportArray), function(info, index) {
    return _c('div', {
      key: index
    }, [_c('supportCard', {
      attrs: {
        "infoCard": info,
        "index": index
      },
      on: {
        "goTo": _vm.clickOnButton
      }
    })], 1)
  }), 0)]), _vm._v(" "), (_vm.virtual_pd_session_modal) ? _c('virtual-pd-session-modal', {
    on: {
      "close": function($event) {
        _vm.virtual_pd_session_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.virtual_class_visit_modal) ? _c('virtual-class-visit-modal', {
    on: {
      "close": function($event) {
        _vm.virtual_class_visit_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content_concierge_modal) ? _c('content-concierge-modal', {
    on: {
      "close": function($event) {
        _vm.content_concierge_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a50fd10e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/support_&_PD/support_&_PD.vue
// module id = 2327
// module chunks = 61